<div class="calendrier-header">
	<div class="header-left">
		<div class="container-changement-mois">
			<p-button
					class="button-changement-mois"
					icon="pi pi-angle-left"
					(click)="changerDeMoisOuSemaineAvecFlecheDirectionnelle(-1)"/>
			<p-button
					class="button-changement-mois"
					icon="pi pi-angle-right"
					(click)="changerDeMoisOuSemaineAvecFlecheDirectionnelle(1)"/>
		</div>
		<p-calendar
				styleClass="inner-calendar"
				[(ngModel)]="dateCourante"
				view="{{ TypeChangementDate.MOIS ? 'month' : 'date' }}"
				dateFormat="MM yy"
				[readonlyInput]="true"
				(ngModelChange)="changerDeDate()"/>
	</div>
	<div class="header-right">
		<p-button
				label="{{ 'CALENDRIER_JOURS_TELETRAVAIL.AUJOURDHUI' | translate }}"
				icon="pi pi-calendar"
				class="button-aujourdhui"
				[disabled]="estDateActuelleEgaleMoisSemaineCourant()"
				(click)="retournerAuMoisOuSemaineCourant()">
		</p-button>
	</div>
</div>
